import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Label, Input, FormGroup, FormFeedback, Col } from 'reactstrap';
import i18n from '../../../i18next';

import {
    loadRestaurantSettings,
    dispatchErrorMessage
} from '../../../actions/index';
import { COLLECTION_ID, DELIVERY_ID } from '../../../utils/Constants';

const ADD_COLLECTION = {
    id: COLLECTION_ID,
    value: 'Collection'
};

const ADD_DELIVERY = {
    id: DELIVERY_ID,
    value: 'Delivery'
};

const ADD_DINEIN = {
    id: 3,
    value: 'Dine In'
};

const ADD_CURBSIDE = {
    id: 4,
    value: 'Curbside'
};

const ADD_INSTORE = {
    id: 5,
    value: 'In Store'
};

class PromotionAdvancedScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            restaurantId: null,
            supportedOrderTypes: null,
            orderTypes: null,
            collection: false,
            delivery: false,
            dinein: false,
            curbside: false,
            instore: false,
            freeDelivery: null,
            discountNonDiscountableProducts: null,
            allowMultipleDiscounts: null,
            invalidForm: false,
            stateAlreadyCopiedFromProps: false
        };
    }

    componentDidMount() {
        let restaurantId = this.props.restaurantId;
        this.props.loadRestaurantSettings(restaurantId);
    }

    updateDeliveryOptions() {
        let updatedOrderTypes = null;

        if (this.state.collection) {
            updatedOrderTypes = this.addToDeliveryOptions(updatedOrderTypes, ADD_COLLECTION);
        } else {
            updatedOrderTypes = this.removeFromDeliveryOption(updatedOrderTypes, 'Collection');
        }

        if (this.state.delivery) {
            updatedOrderTypes = this.addToDeliveryOptions(updatedOrderTypes, ADD_DELIVERY);
        } else {
            updatedOrderTypes = this.removeFromDeliveryOption(updatedOrderTypes, 'Delivery');
        }

        // if (this.state.dinein) {
        //     updatedOrderTypes = this.addToDeliveryOptions(updatedOrderTypes, ADD_DINEIN);
        // } else {
        //     updatedOrderTypes = this.removeFromDeliveryOption(updatedOrderTypes, 'Dine In');
        // }

        if (this.state.curbside) {
            updatedOrderTypes = this.addToDeliveryOptions(updatedOrderTypes, ADD_CURBSIDE);
        } else {
            updatedOrderTypes = this.removeFromDeliveryOption(updatedOrderTypes, 'Curbside');
        }

        if (this.state.instore) {
            updatedOrderTypes = this.addToDeliveryOptions(updatedOrderTypes, ADD_INSTORE);
        } else {
            updatedOrderTypes = this.removeFromDeliveryOption(updatedOrderTypes, 'In Store');
        }
    }

    addToDeliveryOptions(updatedOrderTypes, orderTypeObject) {
        updatedOrderTypes = [...this.state.orderTypes, orderTypeObject];
        this.state.orderTypes = updatedOrderTypes;
    }

    removeFromDeliveryOption(updatedOrderTypes, orderTypeString) {
        updatedOrderTypes = _.remove(this.state.orderTypes, function (orderType) {
            if (orderType.value !== orderTypeString) {
                return orderType;
            }
        });

        this.state.orderTypes = updatedOrderTypes;
    }

    componentWillUnmount() {
        this.updateDeliveryOptions();
        this.props.getPageData(this.state);
    }

    orderTypeSupported(orderType) {
        let option = false;
        this.props.orderTypes.map(type => {
            if (type.value === orderType) {
                return option = true;
            }
        });

        return option;
    }

    copyStateFromProps() {
        if (this.props.supportedOrderTypes !== null && this.props.supportedOrderTypes !== undefined &&
            (this.state.stateAlreadyCoppiedFromProps === false || this.props.restaurantId !== this.state.restaurantId)) {

            let collection = false;
            let delivery = false;
            let dinein = false;
            let curbside = false;
            let instore = false;
            if (this.props.orderTypes) {
                collection = this.orderTypeSupported('Collection');
                delivery = this.orderTypeSupported('Delivery');
                dinein = this.orderTypeSupported('Dine In');
                curbside = this.orderTypeSupported('Curbside');
                instore = this.orderTypeSupported('In Store');
            }
            // If we support delivery show freeDelivery option
            let freeDelivery = false;
            if (delivery) {
                freeDelivery = false;
            }

            this.setState({
                restaurantId: this.props.restaurantId,
                orderTypes: this.props.orderTypes ? this.props.orderTypes : [],
                supportedOrderTypes: this.props.supportedOrderTypes,
                collection: this.props.orderTypes ? collection : true,
                delivery: this.props.orderTypes ? delivery : true,
                dinein: this.props.orderTypes ? dinein : true,
                curbside: this.props.orderTypes ? curbside : true,
                instore: this.props.orderTypes ? instore : true,
                freeDelivery: this.props.freeDelivery ? this.props.freeDelivery : freeDelivery,
                discountNonDiscountableProducts: this.props.discountNonDiscountableProducts,
                allowMultipleDiscounts: this.props.allowMultipleDiscounts,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    updateCheckboxState({ target }) {
        if (target.name === 'delivery') {
            (target.value === 'true') ? this.setState({ ...this.state, [target.name]: false, freeDelivery: false }) : this.setState({ ...this.state, [target.name]: true });
        } else {
            this.setState({
                ...this.state,
                [target.name]: target.checked
            });
        }
    }

    handleTabValidation() {
        const { collection, delivery, dinein, curbside } = this.state;
        let validFormData = true;

        if (!collection && !delivery && !dinein && !curbside) {
            // this.setState({...this.state, invalidForm: true});
            this.state.invalidForm = true;
            this.props.cancelTabChangeRequest();
            validFormData = false;
            return validFormData;
        }

        return validFormData;
    }

    submitForm() {
        let validFormData = this.handleTabValidation();
        // If tab data is valid go to next page or submit the form
        if (validFormData) {
            this.props.goToNextPage();
        } else { // If not tell the parent component that form is invalid
            this.props.setInvalidTabData();
        }
    }

    renderDeliveryOptions() {
        let deliveryOptions = this.state.supportedOrderTypes.map((option) => {
            let lowerCaseValue = option.value.replace(/ +/g, "").toLowerCase();
            let labelValue = '';
            if (option.value === 'Collection') {
                labelValue = i18n.t('screens:promotionAdvancedScreen.pickUp');
            } else if (option.value === 'In Store') {
                labelValue = i18n.t('screens:promotionAdvancedScreen.dinePay');
            } else if (option.value === 'Delivery') {
                labelValue = i18n.t('screens:promotionAdvancedScreen.delivery');
            } else if (option.value === 'Curbside') {
                labelValue = i18n.t('screens:promotionAdvancedScreen.curbside');
            } else {
                labelValue = option.value;
            }

            return (
                <FormGroup check inline>
                    <Label check style={styles.checkboxesLabel}>{labelValue}</Label>
                    <Input type="checkbox" name={lowerCaseValue} checked={this.state[lowerCaseValue]}
                        value={this.state[lowerCaseValue]} onChange={this.updateCheckboxState.bind(this)}
                    />
                </FormGroup>
            );
        });

        return (
            <div style={styles.checkboxesContainer}>
                {deliveryOptions}
            </div>
        );
    }

    renderFreeDeliveryOption() {
        const { freeDeliveryOption } = styles;

        return (
            <FormGroup check inline style={freeDeliveryOption}>
                <Label check style={styles.checkboxesLabel}>{i18n.t('screens:promotionAdvancedScreen.freeDelivery')}</Label>
                <Input type="checkbox" name='freeDelivery' disabled={!this.state.delivery} checked={this.state.freeDelivery} value={this.state.freeDelivery} onChange={this.updateCheckboxState.bind(this)} />
            </FormGroup>
        );
    }

    renderDiscountsOptions() {

        return (
            <div style={{ ...styles.checkboxesContainer, display: 'flex', flexDirection: 'column' }}>
                <Col sm={12} style={{ padding: 0 }}>
                    <FormGroup check style={{ alignItems: 'flex-start', paddingLeft: 0, marginBottom: '20px' }}>
                        <Label check style={styles.checkboxesLabel}>{i18n.t('screens:promotionAdvancedScreen.nonDiscountables')}</Label>
                        <Input
                            style={{ marginLeft: 0 }}
                            type="checkbox"
                            name="discountNonDiscountableProducts"
                            checked={this.state.discountNonDiscountableProducts}
                            value={this.state.discountNonDiscountableProducts}
                            onChange={this.updateCheckboxState.bind(this)} />
                    </FormGroup>
                </Col>
                <Col sm={12} style={{ padding: 0 }}>
                    <FormGroup check style={{ alignItems: 'flex-start', paddingLeft: 0 }}>
                        <Label check style={styles.checkboxesLabel}>{i18n.t('screens:promotionAdvancedScreen.multipleDiscounts')}</Label>
                        <Input
                            style={{ marginLeft: 0 }}
                            type="checkbox"
                            name="allowMultipleDiscounts"
                            checked={this.state.allowMultipleDiscounts}
                            value={this.state.allowMultipleDiscounts}
                            onChange={this.updateCheckboxState.bind(this)} />
                    </FormGroup>
                    <p style={{ fontSize: 13 }}>*{i18n.t('screens:promotionAdvancedScreen.multipleDiscountsMsg')}</p>
                </Col>
            </div>
        );
    }

    renderError() {

        return (
            <FormGroup>
                <Input type="text" style={{ height: 0, display: 'none' }}
                    invalid={(this.state.invalidForm && (!this.state.collection && !this.state.delivery && !this.state.dinein && !this.state.curbside))}
                />
                <FormFeedback>{i18n.t('screens:promotionAdvancedScreen.atLeastOneOption')}</FormFeedback>
            </FormGroup>
        );
    }

    render() {
        this.copyStateFromProps();

        if (!this.state.supportedOrderTypes) {
            return <div></div>;
        }

        if (this.props.requestTabChange) {
            this.submitForm();
        }

        return (
            <div style={styles.formContainer}>
                {this.renderDeliveryOptions()}
                {this.renderError()}
                {(this.state.delivery !== undefined) ? this.renderFreeDeliveryOption() : null}
                {this.renderDiscountsOptions()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        supportedOrderTypes: state.serviceSettingsGeneral.orderTypes
    }
};

export default connect(mapStateToProps, { loadRestaurantSettings, dispatchErrorMessage })(PromotionAdvancedScreen);

const styles = {
    formContainer: {
        marginTop: 20,
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
        backgroundColor: '#f8f8f8',
        border: '1px solid #E9ECEF'
    },
    checkboxesContainer: {
        marginBottom: 20
    },
    checkboxesLabel: {
        marginRight: 5
    },
    freeDeliveryOption: {
        marginBottom: 20
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/promotions/PromotionAdvancedScreen.js